import { IconPlayButton } from '@troon/icons/play-button';
import { Picture } from '../components/picture';
import { Dialog } from '../overlays/dialog';

type Props = {
	code: string;
	poster: string;
};

export function VimeoVideo(props: Props) {
	return (
		<div class="relative aspect-video w-full overflow-hidden rounded-lg">
			<Dialog key="video">
				<Dialog.Trigger class="size-full outline-none focus-visible:ring-2 focus-visible:ring-brand-100 focus-visible:ring-offset-2">
					<Picture
						src={props.poster}
						class="aspect-(4/3) relative z-0 size-full"
						width={768}
						height={576}
						sizes="(min-width: 1024px) 60, (min-width: 768px) 75vw, 95vw"
						loading="lazy"
					/>
					<span class="absolute inset-0 flex items-center justify-center outline-none focus-visible:ring focus-visible:ring-brand-100 focus-visible:ring-offset-2 active:scale-95 motion-safe:transition-all motion-safe:duration-200">
						<IconPlayButton class="size-16 text-white" />
						<span class="sr-only">Play video</span>
					</span>
				</Dialog.Trigger>
				<Dialog.Container desktopWidth="lg">
					<Dialog.Content>
						<div class="aspect-video min-w-max">
							<iframe
								credentialless
								class="aspect-video size-full rounded-xl"
								src={`https://player.vimeo.com/video/${props.code}?badge=0&autoplay=1&player_id=0&app_id=58479`}
								title="YouTube video player"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
							/>
						</div>
					</Dialog.Content>
				</Dialog.Container>
			</Dialog>
		</div>
	);
}
